(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-trio"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    let sectionSelector = document.querySelector('.section-blog-trio').dataset.seciton;
    let $section = document.querySelector(`#${sectionSelector}`);
    let currentVideo = $section.querySelector('.video_bg');
    let observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && currentVideo) {
          currentVideo?.play().catch(error => console.error('play error:', error));
        }
      });
    }, { threshold: 0.6 });

    observer.observe($section);
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coachella-bundles"] && !Shopify.designMode) return;
  try {
    
  class CoachellaCarousel extends HTMLElement {
      constructor() {
          super();
          this.wrapper = this.querySelector('.coachella-bundles-carousel-wrapper');
          this.slides = this.querySelectorAll('.coachella-bundles-carousel-slide');
          const selector = this.dataset.contentSelector; 
          this.contents = document.querySelectorAll(selector);
          
          this.autoplayInterval = 10000; 
          this.timer = null;
          this.currentIndex = 0;
          
          this.isIntersecting = false;
          this.observer = new IntersectionObserver((entries) => {
              this.isIntersecting = entries[0].isIntersecting;
          }, { threshold: 0.5 }); 

          this.init();
      }

      init() {
          if (!this.slides.length) return;
          this.observer.observe(this); 

          this.pagination = document.createElement('div');
          this.pagination.className = 'coachella-pagination';
          this.appendChild(this.pagination);

          this.slides.forEach((slide, index) => {
              const dot = document.createElement('span');
              dot.className = `dot ${slide.classList.contains('active') ? 'is-active' : ''}`;
              
              dot.addEventListener('click', (e) => {
                  e.stopPropagation();
                  this.switchToIndex(index, true); 
                  this.resetAutoplay();
              });

              slide.addEventListener('click', () => {
                  this.switchToIndex(index, true); 
                  this.resetAutoplay();
              });
              
              this.pagination.appendChild(dot);
              if(slide.classList.contains('active')) this.currentIndex = index;
          });

          this.startAutoplay();
          this.addEventListener('mouseenter', () => this.stopAutoplay());
          this.addEventListener('mouseleave', () => this.startAutoplay());
      }

      /**
      * @param {number} index 目标索引
      * @param {boolean} forceScroll 是否强制滚动（手动点击时设为 true）
      */
      switchToIndex(index, forceScroll = false) {
          this.currentIndex = index;
          const activeSlide = this.slides[index];

          
          this.slides.forEach(s => s.classList.remove('active'));
          activeSlide.classList.add('active');

          const dots = this.querySelectorAll('.dot');
          dots.forEach(d => d.classList.remove('is-active'));
          if (dots[index]) dots[index].classList.add('is-active');

          if (window.innerWidth <= 767) {
              if (forceScroll || this.isIntersecting) {
                  activeSlide.scrollIntoView({
                      behavior: 'smooth',
                      block: 'nearest',
                      inline: 'center'
                  });
              }
          }

          if (this.contents.length > 0) {
              this.contents.forEach(c => {
                  c.classList.remove('active');
                  c.style.display = 'none';
              });
              if (this.contents[index]) {
                  this.contents[index].classList.add('active');
                  this.contents[index].style.display = 'block';
              }
          }

          this.dispatchEvent(new CustomEvent('slideChanged', { detail: { index: index } }));
      }

      startAutoplay() {
          if (window.Shopify && Shopify.designMode) return;
          this.stopAutoplay();
          this.timer = setInterval(() => {
              let nextIndex = (this.currentIndex + 1) % this.slides.length;
              
              this.switchToIndex(nextIndex, false);
          }, this.autoplayInterval);
      }

      stopAutoplay() {
          if (this.timer) clearInterval(this.timer);
      }

      resetAutoplay() {
          this.stopAutoplay();
          this.startAutoplay();
      }
      
      disconnectedCallback() {
          if(this.observer) this.observer.disconnect();
      }
  }

  if (!customElements.get('cp-tab')) {
      customElements.define('cp-tab', CoachellaCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coachella-email-v1"] && !Shopify.designMode) return;
  try {
    
  let coachellaEmailInfoPopupButton = document.querySelector('.coachella-email-info-popup__button');
  let coachellaEmailInfo = coachellaEmailInfoPopupButton.closest(".coachella-email-v1-inner").querySelector('template').innerHTML;
  if (coachellaEmailInfoPopupButton) {
    coachellaEmailInfoPopupButton.addEventListener('click', function () {
      let popupModal = document.querySelector('popup-modal');
      if(popupModal){
          popupModal.classList.remove('inactive');
          popupModal.classList.add('coachellaEmailInfo-popup-modal');
          popupModal.querySelector('.popup-modal__content').innerHTML = coachellaEmailInfo;
      }else{
          var preOrderModalString = `<popup-modal class="popup-modal coachellaEmailInfo-popup-modal">
          <div class="popup-modal__overlay"></div>
          <div class="popup-modal__inner">
              <div class="popup-modal__content">
                  ${coachellaEmailInfo}
              </div>
              <button class="popup-modal__close">
                  <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <line x1="1.11092" y1="0.610962" x2="8.88909" y2="8.38914" stroke="currentColor" stroke-linecap="round"/>
                      <line x1="1.11096" y1="8.38915" x2="8.88914" y2="0.610971" stroke="currentColor" stroke-linecap="round"/>
                  </svg>
              </button>
          </div>
          </popup-modal>`
          var preOrderModal = new DOMParser().parseFromString(preOrderModalString, 'text/html').querySelector('popup-modal')
  
          document.body.append(preOrderModal);
      }
    })
  }

  document.addEventListener('submit', function(e) {
    const form = e.target.closest('#coachella-newsletter-form'); 
    console.log(form)
    if (form) {
      const email = form.querySelector('input[type="email"]').value;
      sessionStorage.setItem('pending_email', email);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const openSearchBtn = document.querySelector('.headersearch-icon-desktop.icon-search');
    const closeSearchBtn = document.querySelector('.headersearch-icon-desktop.icon-close');
    if (!openSearchBtn && !closeSearchBtn) return;
    openSearchBtn.addEventListener('click', function() {
      const nextEl = this.nextElementSibling; 
      if (nextEl && nextEl.classList.contains("headersearch-wrapper-desktop")) {
        nextEl.classList.add('open')
      }
    });
    closeSearchBtn.addEventListener('click', function() {
      this.closest(".headersearch-wrapper-desktop")?.classList.remove('open')
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ipl-ba"] && !Shopify.designMode) return;
  try {
    
    class IplBA extends HTMLElement {
        constructor() {
            super();
            this.btnList = this.querySelector('.btn-list');
            this.buttons = this.querySelectorAll('.btn-list button');
            this.contents = this.querySelectorAll('.content-list .content');
            this.activeIndex = 0;
        }

        connectedCallback() {
            this.btnList.addEventListener('click', (e) => this._onButtonClick(e));
        }

        _onButtonClick(e) {
            const target = e.target.closest('button');
            if (!target) return;

            const newIndex = parseInt(target.dataset.index);
            if (newIndex === this.activeIndex) return;

            this._updateState(newIndex);
        }

        _updateState(index) {
            this.buttons[this.activeIndex].classList.remove('is-active');
            this.buttons[this.activeIndex].setAttribute('aria-selected', 'false');
            this.contents[this.activeIndex].classList.remove('is-active');

            this.buttons[index].classList.add('is-active');
            this.buttons[index].setAttribute('aria-selected', 'true');
            this.contents[index].classList.add('is-active');

            this._ensureBtnInView(this.buttons[index]);
            
            this.activeIndex = index;
        }

        _ensureBtnInView(btn) {
            btn.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'center'
            });
        }
    }

    if (!customElements.get('ipl-ba')) {
        customElements.define('ipl-ba', IplBA);
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ipl-discover"] && !Shopify.designMode) return;
  try {
    
    class IplDiscover extends HTMLElement {
        constructor() {
            super();
            this.selectors = {
                init: '.init',
                applicable: '.applicable',
                inapplicable: '.inapplicable',
                skinButtons: '.skin-options button',
                hairButtons: '.hair-options button',
                resetBtn: '.test-again',
                optionsContainer: '.options'
            };

            this.state = {
                skin: null,
                hair: null,
                isLocked: false
            };
        }

        connectedCallback() {
            this.init();
        }

        init() {
            this.querySelectorAll(this.selectors.skinButtons).forEach(btn => {
            btn.addEventListener('click', () => this.handleSelection('skin', btn));
            });

            this.querySelectorAll(this.selectors.hairButtons).forEach(btn => {
            btn.addEventListener('click', () => this.handleSelection('hair', btn));
            });

            this.querySelectorAll(this.selectors.resetBtn).forEach(btn => {
            btn.addEventListener('click', () => this.reset());
            });
        }

        handleSelection(group, button) {
            if (this.state.isLocked) return;

            const container = button.closest('.h-stack');
            container.querySelectorAll('button').forEach(b => {
            b.classList.remove('is-active');
            b.setAttribute('aria-selected', 'false');
            });
            
            button.classList.add('is-active');
            button.setAttribute('aria-selected', 'true');

            this.state[group] = button;

            this.checkResult();
        }

        checkResult() {
            if (this.state.skin && this.state.hair) {
            this.state.isLocked = true;
            
            this.querySelector(this.selectors.optionsContainer).classList.add('is-disabled');

            const skinInapplicable = this.state.skin.dataset.inapplicable === 'true';
            const hairInapplicable = this.state.hair.dataset.inapplicable === 'true';

            if (skinInapplicable === true || hairInapplicable === true) {
                this.showResult('inapplicable');
            } else {
                this.showResult('applicable');
            }
            } else {
            this.showResult('init');
            }
        }

        showResult(type) {
            const results = ['init', 'applicable', 'inapplicable'];
            results.forEach(res => {
            const el = this.querySelector(this.selectors[res]);
            if (el) el.style.display = (res === type) ? 'block' : 'none';
            });
        }

        reset() {
            this.state.skin = null;
            this.state.hair = null;
            this.state.isLocked = false;

            this.querySelector(this.selectors.optionsContainer).classList.remove('is-disabled');

            this.querySelectorAll('.options button').forEach(b => {
            b.classList.remove('is-active');
            b.setAttribute('aria-selected', 'false');
            });

            this.showResult('init');
        }
    }

    if (!customElements.get('ipl-discover')) {
    customElements.define('ipl-discover', IplDiscover);
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ipl-number"] && !Shopify.designMode) return;
  try {
    
    class CountUp extends HTMLElement {
        constructor() {
            super();
            this.hasAnimated = false;
            const rawText = this.innerText.trim();
            this.targetValue = parseFloat(rawText.replace(/[^0-9.]/g, '')) || 0;
            this.unit = rawText.replace(/[0-9.]/g, '');
            this.duration = 2000; 
        }

        connectedCallback() {
            this.render(0);
            this.setupObserver();
        }

        setupObserver() {
            const observer = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting && !this.hasAnimated) {
                this.animateValue();
                this.hasAnimated = true;
                observer.unobserve(this);
            }
            }, { threshold: 0.1 });

            observer.observe(this);
        }

        render(value) {
            const displayValue = typeof value === 'number' ? value.toFixed(2) : value;
            this.innerHTML = `${displayValue}${this.unit ? `<sup>${this.unit}</sup>` : ''}`;
        }

        animateValue() {
            let startTimestamp = null;
            const step = (timestamp) => {
                if (!startTimestamp) startTimestamp = timestamp;
                const progress = Math.min((timestamp - startTimestamp) / this.duration, 1);
                
                const easeProgress = progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress);
                const currentValue = easeProgress * this.targetValue;
                
                this.render(currentValue);

                if (progress < 1) {
                    window.requestAnimationFrame(step);
                } else {
                    this.render(this.targetValue);
                }
            };
            window.requestAnimationFrame(step);
        }
    }
    customElements.define('count-up', CountUp);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["led-video-slides"] && !Shopify.designMode) return;
  try {
    
  const sections = document.querySelectorAll('.section-led-video-slides-container');
  
  sections.forEach($section => {
    const videoSlides = $section.querySelectorAll('.click-to-play');

    videoSlides.forEach(element => {
      element.addEventListener('click', function(e) {
        const currentVideo = this.querySelector('video');
        if (!currentVideo) return;

        if (e.target.closest('.muted_btn')) return;

        if (currentVideo.paused) {
          this.classList.add('active');
          const playPromise = currentVideo.play();
          
          if (playPromise !== undefined) {
            playPromise.catch(error => {
              console.log("Auto-play prevented, retry with muted");
              currentVideo.muted = true;
              currentVideo.play();
            });
          }
        } else {
          this.classList.remove('active');
          currentVideo.pause();
        }
      });
    });

    const mutedBtns = $section.querySelectorAll('.muted_btn');
    mutedBtns.forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation(); 
        const video = this.closest('.click-to-play').querySelector('video');
        if (video) {
          video.muted = !video.muted;
          this.classList.toggle('is-muted', video.muted);
          if (!video.paused) video.play();
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pillar-video-scroll"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('.p-video-scroll-carousel-section');
  const videoWrapper = container.querySelector('.video_wrapper');
  const mediaElement = container.querySelector('.media');
  const playButton = container.querySelector('#playTrigger');

  if (!videoWrapper || !mediaElement) return;

  playButton.addEventListener('click',function(){
    console.log(12)
    this.style.display = "none"; 
    mediaElement.querySelector('video').play();
  })

  const targetWidthPx = parseInt(mediaElement.dataset.maxWidth) || 650;

  const handleScroll = () => {
    if (window.innerWidth < 768) {
        mediaElement.style.width = '';
        mediaElement.style.borderRadius = '';
        return;
    }
    const rect = videoWrapper.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    const wrapperHeight = rect.height;

    let progress = -rect.top / (wrapperHeight - viewportHeight);
    progress = Math.max(0, Math.min(1, progress));

    const fullWidthPx = videoWrapper.offsetWidth;

    if (fullWidthPx > targetWidthPx) {
      const targetRatio = (targetWidthPx / fullWidthPx) * 100;
      const startRatio = 100;

      const currentWidthRatio = startRatio - (progress * (startRatio - targetRatio));
      
      mediaElement.style.width = `${currentWidthRatio}%`;
    } else {
      mediaElement.style.width = '100%';
    }

    const borderRadius = progress * 24; 
    mediaElement.style.borderRadius = `${borderRadius}px`;
  };

  window.addEventListener('scroll', () => {
    window.requestAnimationFrame(handleScroll);
  }, { passive: true });

  window.addEventListener('resize', handleScroll);

  handleScroll();
});

  } catch(e) { console.error(e); }
})();
})();
